export enum ViewTypeEnum {
  softval = "d-solo",
  grafana = "d",
}

export enum GrafanaTiType {
  PART_FSM = "PART.FSM",
  P_PROD = "P.PROD",
  F_PROD = "F.PROD",
  PC = "PC",
  SOC_EDR = "SOC.EDR",
  RSFP = "RSFP",
  RET_RSFP = "RET.RSFP",
}
